import React from 'react';
import styled from 'styled-components';
import { SearchInput } from '../SearchInput/SearchInput';
import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import trackingContext from '../../../contexts/tracking-context';
import { trackMapSearchFormSubmitAction } from '../../../utils/trackingUtils';
import { useURLService } from '../../../hooks/useURLService';
import type { UnifiedTheme } from '../../../FeatureApp';

export const SearchForm = () => {
  const { searchText, userSelectedFilters } = mapContext.useMapState();
  const dispatch = mapContext.useMapDispatch();
  const { trackingService: tService } = trackingContext.useTrackingState();
  const generateURL = useURLService();

  function onSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const currentUrl = window.location.href;
    const payload = {
      query: searchText,
      filters: userSelectedFilters,
    };
    const url = generateURL(currentUrl, payload);

    trackMapSearchFormSubmitAction(tService, searchText, 'SearchForm', url.href);

    dispatch({
      type: ActionTypes.setSelectedDealerId,
      payload: null,
    });
    dispatch({ type: ActionTypes.setDealerReviews, payload: [] });
    dispatch({ type: ActionTypes.setPlaceId, payload: '' });
    dispatch({ type: ActionTypes.setQuery, payload: searchText });
    dispatch({ type: ActionTypes.setIsAutocompletionOpen, payload: false });
    dispatch({ type: ActionTypes.setLastSubmittedSearch, payload: searchText });
  }

  return (
    <SearchFormContainer data-test-id="search-form" onSubmit={onSubmit}>
      <SearchInput />
    </SearchFormContainer>
  );
};

export default SearchForm;

const SearchFormContainer = styled.form`
  background-color: ${(props: UnifiedTheme) =>
    props.theme.sys.color.canvas[200] || props.theme.sys.color.canvas.default};
  width: 100%;
  input {
    width: 100%;
  }
`;
